/**
 * Diagnostic détaillé de la configuration Keycloak
 * À exécuter au démarrage de l'application
 */

import { environment } from '../environments/environment';

export function runDetailedKeycloakDiagnostic(): void {
  if (typeof window === 'undefined') {
    return;
  }

  // 1. Configuration Keycloak de l'environnement
  // Configuration Keycloak disponible dans environment.keycloak

  // 2. URLs actuelles du navigateur
  // Informations disponibles via window.location

  // 3. Redirect URIs qui seront utilisés
  const dashboardRedirectUri = window.location.origin + '/panel/dashboard';
  const silentCheckSsoUri = window.location.origin + '/silent-check-sso.html';
  const homeRedirectUri = window.location.origin + '/';

  // 4. URLs Keycloak complètes
  const baseUrl = environment.keycloak.url.replace(/\/$/, '');
  const loginUrl = `${baseUrl}/realms/${environment.keycloak.realm}/protocol/openid-connect/auth`;
  const logoutUrl = `${baseUrl}/realms/${environment.keycloak.realm}/protocol/openid-connect/logout`;
  const tokenUrl = `${baseUrl}/realms/${environment.keycloak.realm}/protocol/openid-connect/token`;

  // 5. URL de login complète avec paramètres
  const loginUrlWithParams = `${loginUrl}?client_id=${environment.keycloak.clientId}&redirect_uri=${encodeURIComponent(dashboardRedirectUri)}&response_type=code&scope=openid`;

  // 6. Vérifier si on est sur une page de retour Keycloak
  const urlParams = new URLSearchParams(window.location.search);
  const hasKeycloakParams = urlParams.has('code') || urlParams.has('error') || urlParams.has('state');

  if (hasKeycloakParams) {
    // Paramètres Keycloak détectés dans l'URL
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    const sessionState = urlParams.get('session_state');
  }

  // 7. Configuration à ajouter dans Keycloak Admin
  // Client ID: environment.keycloak.clientId
  // Realm: environment.keycloak.realm
  // Valid Redirect URIs: window.location.origin + '/*', dashboardRedirectUri, silentCheckSsoUri, homeRedirectUri
  // Web Origins: window.location.origin, '*'

  // 8. Vérifications de sécurité
  const checks = [
    { name: 'Protocole HTTPS en production', pass: !environment.production || window.location.protocol === 'https:' },
    { name: 'Keycloak URL valide', pass: environment.keycloak.url.startsWith('http') },
    { name: 'Client ID configuré', pass: !!environment.keycloak.clientId },
    { name: 'Realm configuré', pass: !!environment.keycloak.realm },
  ];

  // Vérifications effectuées (résultats disponibles dans checks)
  checks.forEach(check => {
    // Vérification: ${check.pass ? '✅' : '❌'} ${check.name}
  });
}

